import { ReactComponent as OrderIcon } from '../assets/icons/order.svg';
import { ReactComponent as CookIcon } from '../assets/icons/cook.svg';
import { ReactComponent as DeliveryIcon } from '../assets/icons/delivery.svg';

export const galleryData = [
  {
    picture: 'assets/images/gallery1.jpg',
    desc: 'berries and bananas in a bowl',
  },
  {
    picture: 'assets/images/gallery2.jpg',
    desc: 'pancakes and berries on a plate',
  },
  {
    picture: 'assets/images/gallery3.jpg',
    desc: 'berries, grapes and pancakes with honey',
  },
  {
    picture: 'assets/images/gallery4.jpg',
    desc: 'pancakes cut in half and strawberries',
  },
  {
    picture: 'assets/images/gallery5.jpg',
    desc: 'chicken and rice',
  },
  {
    picture: 'assets/images/gallery6.jpg',
    desc: 'fried egg and vegetables',
  },
  {
    picture: 'assets/images/gallery7.jpg',
    desc: 'bread, eggs and vegetables',
  },
  {
    picture: 'assets/images/gallery8.jpg',
    desc: 'chocolate bread and something else',
  },
  {
    picture: 'assets/images/gallery9.jpg',
    desc: 'bowl of cereals with sliced fruits and spoon',
  },
  {
    picture: 'assets/images/gallery10.jpg',
    desc: 'plate of vegetables',
  },
];

export const ProcessData = [
  {
    id: 1,
    title: 'Make an order',
    content:
      'Browse our mouthwatering menu and select your favorite breakfast or brunch items. Customize your order to fit your cravings and dietary preferences.',
    icon: OrderIcon,
  },
  {
    id: 2,
    title: 'We cook',
    content:
      'Our talented chefs get to work crafting your meal with the freshest ingredients available. Every dish is prepared with care and attention to ensure it\'s bursting with flavor.',
    icon: CookIcon,
  },
  {
    id: 3,
    title: 'Fast Delivery',
    content:
      'Sit back and relax as we swiftly deliver your freshly cooked breakfast straight to your doorstep. Enjoy the convenience of a delicious meal without any hassle.',
    icon: DeliveryIcon,
  },
];

export const slidesData = [
  
  {
    id: 1,
    name: 'Poached Eggs on Toast',
    desc: 'Indulge in perfectly poached eggs delicately placed on toasted artisan bread. A classic breakfast choice that never fails to satisfy.',
    price: '13.99',
    image: 'assets/images/slide1.png',
  },
  {
    id: 2,
    name: 'Turkey Sandwich',
    desc: 'Experience the savory goodness of thinly sliced turkey nestled between slices of fresh bread. Topped with crisp lettuce, juicy tomatoes, and creamy mayo for a satisfying bite.',
    price: '24.99',
    image: 'assets/images/slide2.png',
  },
  {
    id: 3,
    name: 'Avocado Toast',
    desc: 'Elevate your morning with our signature avocado toast. Creamy avocado spread atop hearty whole grain bread, sprinkled with a dash of sea salt and red pepper flakes for a burst of flavor.',
    price: '19.99',
    image: 'assets/images/slide3.png',
  },
  {
    id: 4,
    name: 'Eggs and Cheese',
    desc: 'Indulge in a comforting combination of fluffy scrambled eggs mixed with gooey melted cheese. Perfectly paired with your choice of sides for a hearty and wholesome breakfast.',
    price: '19.99',
    image: 'assets/images/slide4.png',
  },
  
  // {
  //   id: 5,
  //   name: 'Fruity waffles',
  //   desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam optio incidunt illum nobis tenetur impedit quibusdam maxime suscipit, omnis eiu',
  //   price: '12.99',
  //   image: 'assets/images/slide.png',
  // },
  // {
  //   id: 6,
  //   name: 'The complete breakfast',
  //   desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam optio incidunt illum nobis tenetur impedit quibusdam maxime suscipit, omnis eiu',
  //   price: '19.99',
  //   image: 'assets/images/slide4.png',
  // }
];
